import styled, { css } from 'styled-components';

import { TileVariation } from '../../ui/Tile';
import { rem } from '../../utils';

export const StyledWrapper = styled.div`
  display: flex;
  width: 100%;
  align-items: center;
  justify-content: center;
`;

export const StyledList = styled.ul<{
  variant: TileVariation;
  columns: number;
}>`
  display: grid;
  width: 100%;
  flex-wrap: wrap;
  list-style: none;
  padding: 0;
  margin: 0;
  justify-content: left;

  ${({ columns, variant, theme }) => {
    const gap =
      variant === 'full'
        ? rem(theme.Components.Tile.Spacing.Small)
        : rem(theme.Components.Tile.Spacing.XSmall);

    return css`
      grid-template-columns: repeat(auto-fill, minmax(calc(${100 / columns}% - ${gap}), 1fr));
      column-gap: ${gap};
      row-gap: ${gap};
    `;
  }}
`;

export const StyledListItem = styled.li<{ variant: TileVariation }>`
  display: inline-flex;
  width: ${({ variant }) => (variant === 'full' ? '100%' : 'auto')};
`;
